// src/directives/v-intersect.ts
import { DirectiveBinding } from "vue";

interface IntersectOptions {
  root?: Element | null;
  rootMargin?: string;
  threshold?: number | number[];
  callback: (entry: IntersectionObserverEntry, observer: IntersectionObserver) => void;
}

interface ElementWithObserver extends Element {
  _observer?: IntersectionObserver;
}

export default {
  mounted(el: ElementWithObserver, binding: DirectiveBinding<IntersectOptions>) {
    const options: IntersectionObserverInit = {
      root: binding.value.root || null,
      rootMargin: binding.value.rootMargin || "0px",
      threshold: binding.value.threshold || 0.1, // Valor por defecto del threshold
    };

    const observer = new IntersectionObserver(([entry], observer) => {
      binding.value.callback(entry, observer);
    }, options);

    el._observer = observer; // Usar la propiedad extendida
    observer.observe(el);
  },
  unmounted(el: ElementWithObserver) {
    if (el._observer) {
      el._observer.disconnect();
      delete el._observer;
    }
  },
};
